/**
 * forgotPass.jsx
 */
import axios from "axios";
import React, {useState} from "react";
import {Link} from "react-router-dom";
import '../../style/forgotPass.css';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
//import ErrorMessage from "../Misc/ErrorMessage";

function ForgotPass () {
    const [restEmail, setResetEmail] = useState("");

   
    /**
     * function passReset()
     * sends a request to server to reset password
     * if the provided email is linked to an account, the request will be handled
     * if not the request will be rejected
     */
    async function passReset() {

        const passwordReset = {
            email: restEmail
        };

        await axios.put("https://link2rsvp.herokuapp.com/auth/passwordreset/", passwordReset);
        setResetEmail("");
    }

    return (
        <div>
            <div id="forgotPass">
                <h3 id="forgot">Forgot Password?</h3>
                <p>If there is an account linked to your email, We will send you an email with instructions on how to reset your password.</p>
                <form>
                    <Form.Group className="mb-3" id="reset">
                        <Form.Label htmlFor="reset">Please enter your email</Form.Label>
                        <Form.Control
                        type="email"
                        name="reset"
                        placeholder="Enter your Email"
                        value={restEmail}
                        onChange={(e) => setResetEmail(e.target.value)}
                        required
                        />
                    </Form.Group>
                    
                    <Button
                    id="passReset"
                    variant="secondary"
                    style={{margin: "auto", marginLeft: "35%", width: "30%", backgroundColor: "#890E32"}}
                    onClick={passReset}
                    >
                        Submit
                    </Button>
                </form>
                <p id="backLogin">
                    <Link to="/login">Back to Login.</Link>
                </p>
            </div>
        </div>
    );
}

export default ForgotPass;